import flatpickr from 'flatpickr/dist/flatpickr.js';

const dateFormat = 'Y/m/d';
const timeFormat = 'H:i';

function wireUpDatePickers() {
  const options = {
    static: true,
    dateFormat: dateFormat,
  };
  const pickers = document.querySelectorAll('.datepicker');
  for(const picker of pickers) {
    flatpickr(picker, options);
  }
}

function wireUpTimePickers() {
  const options = {
    static: true,
    enableTime: true,
    timeFormat: timeFormat,
  };
  const pickers = document.querySelectorAll('.timepicker');
  for(const picker of pickers) {
    flatpickr(picker, options);
  }
}

function wireUpDateTimePickers() {
  const options = {
    static: true,
    enableTime: true,
    timeFormat: timeFormat,
    dateFormat: dateFormat,
  };
  const pickers = document.querySelectorAll('.datetimepicker');
  for(const picker of pickers) {
    flatpickr(picker, options);
  }
}

function setup() {
  wireUpDatePickers();
  wireUpTimePickers();
  wireUpDateTimePickers();
}

export default setup;